export default __webpack_public_path__ + "baee6774dae936d40d908ad8babf0e95.woff2";